import React, { useEffect, useState } from 'react'
import ReactGA from 'react-ga4'
import { useRouter } from 'next/router'

import StreamAd from 'components/advertisments/StreamAd'

import Icon from 'components/elements/Icon'
import { CustomAdInfo, getAdInfo } from 'components/advertisments/CustomAd'

import styles from './fixedAd.module.scss'
import { useAdFree, useAdFreeTrialStatus } from 'hooks/adFree'

type Props = {
  id: string
  className?: string
}

const FixedAd = ({ id, className }: Props) => {
  const router = useRouter()

  const [closed, setClosed] = useState(false)
  const [customAd, setCustomAd] = useState<CustomAdInfo | null>(null)

  const adFree = useAdFree()
  const [adFreeStatus] = useAdFreeTrialStatus()

  const internalLink = (customAd?.adHref || '')[0] === '/'

  useEffect(() => {
    setClosed(false)
  }, [router.asPath])

  useEffect(() => {
    const ad = getAdInfo(['tcg'], adFreeStatus)

    ReactGA.event({ category: 'Ad', action: 'Rendered fixed mobile ad TOTAL' })
    ReactGA.event({ category: 'Ad', action: `Rendered fixed mobile ad - ${ad.adType}` })

    setCustomAd(ad)
  }, [])

  const handleGALog = () => {
    ReactGA.event({ category: 'Ad', action: `Clicked ${customAd?.adType} fixed mobile ad` })
  }

  if (adFree) return null
  if (closed) return null

  return (
    <div className={`${styles.container} ${className}`}>
      <div className={styles.adContainer} id={id}>
        <button type="button" className={styles.close} onClick={() => setClosed(true)}>
          <Icon name="close" />
        </button>

        <a href="https://www.patreon.com/archidekt" rel="noopener noreferrer" target="_blank">
          <Icon name="patreon" />
          Support us on Patreon to remove ads!
        </a>

        <StreamAd />

        {customAd && (
          <a
            href={customAd.adMobileHref ?? customAd.adHref}
            target={internalLink ? undefined : '_blank'}
            className={styles.mobileAdheasion}
            onClick={handleGALog}>
            <img src={customAd.adMobileUrl} />
          </a>
        )}
      </div>
    </div>
  )
}

export default FixedAd
